export default "__VITE_ASSET__CLeaJXMi__"